import React, { useState, useEffect } from 'react';
import { Button, Container, Box, Grid, TextField, Autocomplete, FormControlLabel, Checkbox, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import Title from '../../Title';
import Notify from '../../Notify';
import { getData, putData } from '../../../services/library';

export default function EditarBancos_cuentas(props) {
    const [datos, setDatos] = useState(props.datos);
    const [tipoMoneda, settipoMoneda] = useState(null);
    const [proveedores, setProveedores] = useState('');
    const [proveedorSelected, setproveedorSelected] = useState("");
    const [disbtn, setDisBtn] = useState(false);
    const [notificacion, setNotificacion] = useState({
        open: false,
        mensaje: "",
        severity: "",
        color: "",
    });

    useEffect(() => {
        getData('/proveedores/activos', setProveedores)
        getData('/desplegables/tipoMoneda', settipoMoneda)
    }, [])

    useEffect(() => {
        if (proveedores) {
            const proveedor = proveedores.filter((proveedores) => proveedores.id === datos.id_proveedor)
            setproveedorSelected(proveedor[0])
        }
    }, [proveedores]);

    const almacenar = (e) => {
        setDatos({ ...datos, [e.target.name]: e.target.value ? e.target.value : "" })
    };

    const style = {
        backgroundColor: "#ffffff",
        width: "100%"
    };

    const handleClose = () => {
        props.tabla(true)
        props.editar(false)
        props.actualizar()
    };

    const handleSubmit = (e) => {
        setDisBtn(true);
        putData(e,
            '/bancos_cuentas/'+datos.id_bancos_cuentas,
            {
                codigo: datos.codigo,
                id_proveedor: proveedorSelected.id,
                cbu: datos.cbu,
                nro_cuenta: datos.nro_cuenta,
                cuenta_contable: datos.cuenta_contable,
                apto_cobranzafce: datos.apto_cobranzafce,
                id_moneda: datos.id_moneda,
                saldo_actual: datos.saldo_actual,
                saldo_pendiente: datos.saldo_pendiente,
                usuario: localStorage.getItem('user'),
                activo: 1
            },
            setNotificacion
        )
    };

    return (
        <div>
            <Container>
                <Title titulo={"Editar cuenta"} handleClose={handleClose} />
                <form autoComplete='off' onSubmit={handleSubmit}>
                    <Box backgroundColor="#F4F6F6"
                        mt={1}
                        p={3}
                        mb={2}
                        border={0.5}
                        borderColor={"#ABB2B9"}
                        borderRadius={4}>
                        <Grid container spacing={2} alignItems='center' >
                            <Grid item xs={2}>
                                <TextField
                                    style={style}
                                    required
                                    focused
                                    name="codigo"
                                    label='Código'
                                    value={datos.codigo}
                                    onChange={almacenar}
                                    placeholder='00' />
                            </Grid>
                            <Grid item xs={5}>
                                <Autocomplete
                                    fullWidth
                                    noOptionsText={"Proveedor INEXISTENTE"}
                                    value={proveedorSelected}
                                    options={proveedores}
                                    getOptionLabel={(p) => p.nombre_fantasia ?? p.razon_social}
                                    onChange={(event, value) => setproveedorSelected(value)}
                                    isOptionEqualToValue={(option, value) => (option.nombre_fantasia ?? option.razon_social) === (value.nombre_fantasia ?? option.razon_social)}
                                    renderOption={(props, option) => (
                                        <Box
                                            component="li"
                                            key={option.id}
                                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                                            {...props}
                                        >
                                            {option.nombre_fantasia ?? option.razon_social} - {option.nro_cuit}
                                        </Box>
                                    )}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            focused
                                            color="primary"
                                            required
                                            label="Proveedor"
                                            style={style}
                                            inputProps={{ ...params.inputProps }}
                                        />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={5}>
                                <TextField
                                    name="cbu"
                                    focused
                                    label="CBU"
                                    style={style}
                                    value={datos.cbu}
                                    onChange={almacenar} />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    name="nro_cuenta"
                                    label="Número de cuenta"
                                    style={style}
                                    focused
                                    value={datos.nro_cuenta}
                                    onChange={almacenar}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    name="cuenta_contable"
                                    label="Cuenta contable"
                                    style={style}
                                    focused
                                    value={datos.cuenta_contable}
                                    onChange={almacenar}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <FormControlLabel
                                    label="Apto cobranza FCE"
                                    labelPlacement='start'
                                    checked={datos.apto_cobranzafce === 1}
                                    control={
                                        <Checkbox
                                            name="apto_cobranzafce"
                                            onChange={(e) =>
                                                setDatos({ ...datos, "apto_cobranzafce": e.target.checked ? 1 : 0 })}
                                        />
                                    } />
                            </Grid>
                            <Grid item xs={4}>
                                <FormControl style={style} focused required>
                                    <InputLabel>Moneda</InputLabel>
                                    <Select
                                        name="id_moneda"
                                        label="Moneda"
                                        value={datos.id_moneda || ""}
                                        onChange={almacenar}
                                    >
                                        {(tipoMoneda ?? []).map(elemento => (
                                            <MenuItem key={elemento.id} value={elemento.id}>
                                                {elemento.valor}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    name="saldo_actual"
                                    label="Saldo Actual"
                                    focused
                                    style={style}
                                    value={datos.saldo_actual}
                                    onChange={almacenar}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <TextField
                                    name="saldo_pendiente"
                                    label="Saldo Pendiente"
                                    style={style}
                                    focused
                                    value={datos.saldo_pendiente}
                                    onChange={almacenar} />
                            </Grid>
                        </Grid>
                    </Box>
                    <Grid mt={2}
                        container
                        direction="row"
                        justifyContent="space-between"
                        alignItemns="center"
                    >
                        <Button
                            variant='contained'
                            color="error"
                            onClick={handleClose}>
                            Volver
                        </Button>
                        <Button
                            disabled={disbtn}
                            variant="contained"
                            color="success"
                            type='submit'>
                            Guardar
                        </Button>
                    </Grid>
                    {notificacion && notificacion.open ? (
                        <Notify
                            mensaje={notificacion.mensaje}
                            open={notificacion.open}
                            color={notificacion.color}
                            handleClose={handleClose}
                            severity={notificacion.severity}
                        />
                    ) : null}
                </form>
            </Container>
        </div>
    )
}